import React from 'react';
import Avatar from '@mui/material/Avatar';
import { Box } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { Buyer } from '../../../../../Models/Buyer';

interface UserAvatarProps {
  buyer?: Buyer;
  onClick: () => void;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ buyer, onClick }) => {
  return (
    <div className="navbar-right-user-profile-icon" onClick={onClick}>
      <Avatar
        alt={buyer?.fullName}
        src={buyer?.profileImage}
        sx={{ width: 50, height: 50 }}>
        <Box sx={{ height: "100%", width: "100%", bgcolor: deepOrange[500] }} className="center">
          {buyer?.fullName[0]}
        </Box>
      </Avatar>
    </div>
  );
};

export default UserAvatar;
